module.exports = __webpack_public_path__ + "img/red-desert-decal-00.9e1138f2.png";